<tg-row class="summary-page-rental-details-section__header">
    <tg-col md="6" sm="12">
        <p class="p-lead-copy">Listing details</p>
    </tg-col>
    <tg-col
        md="6"
        sm="12"
        class="summary-page-rental-details-section__header--right"
    >
        <a
            routerLink="../{{ stepIds.propertyInformation }}"
            routerLinkActive="active"
            class="h-link-no-visited"
            >Edit rental details</a
        >
    </tg-col>
</tg-row>
<tg-row>
    <tg-col class="summary-page-rental-details-section__content">
        <span class="summary-page-rental-details-section__content-label"
            >Rent per week:</span
        >
        ${{ rentPerWeek }}
    </tg-col>
</tg-row>
<tg-row>
    <tg-col class="summary-page-rental-details-section__content">
        <span class="summary-page-rental-details-section__content-label"
            >Available from:</span
        >
        {{ availableFrom | tgDateTime: { format: 'long' } }}
    </tg-col>
</tg-row>
<tg-row>
    <tg-col class="summary-page-rental-details-section__content">
        <span class="summary-page-rental-details-section__content-label"
            >Maximum tenants:</span
        >
        {{ maximumTenants }}
    </tg-col>
</tg-row>
<tg-row>
    <tg-col class="summary-page-rental-details-section__content">
        <span class="summary-page-rental-details-section__content-label"
            >Pets OK:</span
        >
        {{ petsOK }}
    </tg-col>
</tg-row>
<tg-row>
    <tg-col class="summary-page-rental-details-section__content">
        <span class="summary-page-rental-details-section__content-label"
            >Smokers OK:</span
        >
        {{ smokersOK }}
    </tg-col>
</tg-row>
<tg-row>
    <tg-col class="summary-page-rental-details-section__content">
        <span class="summary-page-rental-details-section__content-label"
            >Mobile:</span
        >
        {{ mobile }}
    </tg-col>
</tg-row>
<tg-row>
    <tg-col class="summary-page-rental-details-section__content">
        <span class="summary-page-rental-details-section__content-label"
            >Home:</span
        >
        {{ landLine }}
    </tg-col>
</tg-row>
<tg-row>
    <tg-col class="summary-page-rental-details-section__content">
        <span class="summary-page-rental-details-section__content-label"
            >Best contact time:</span
        >
        {{ bestContactTime }}
    </tg-col>
</tg-row>
<tg-row>
    <tg-col class="summary-page-rental-details-section__content">
        <span class="summary-page-rental-details-section__content-label"
            >Are you a registered property agent?:</span
        >
        {{ registeredPropertyAgent }}
    </tg-col>
</tg-row>
<tg-row *ngIf="isPropertyAgent">
    <tg-col class="summary-page-rental-details-section__content">
        <span class="summary-page-rental-details-section__content-label"
            >Agent:</span
        >
        {{ name }}
    </tg-col>
</tg-row>
<tg-row *ngIf="isPropertyAgent">
    <tg-col class="summary-page-rental-details-section__content">
        <span class="summary-page-rental-details-section__content-label"
            >Agency:</span
        >
        {{ agency }}
    </tg-col>
</tg-row>
<tg-row>
    <tg-col class="summary-page-rental-details-section__content">
        <span class="summary-page-rental-details-section__content-label"
            >End date:</span
        >
        {{ endDate }}
    </tg-col>
</tg-row>
<tg-row>
    <tg-col class="summary-page-rental-details-section__content">
        <span class="summary-page-rental-details-section__content-label"
            >Receive tenancy application forms:</span
        >
        {{ isRentiAccepted }}
    </tg-col>
</tg-row>
